import styles from './styles.module.scss';
import typography from '@/styles/typography.module.scss';
import { useTradingHolidaysData } from './UseTradingHolidaysData';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';

export function TradingHolidaysTable() {
  const holidays = useTradingHolidaysData();
  const tr = useTranslations('pages.cfd.all.sections.markets.modal');
  return (
    <div>
      <div className={styles.wrapperItem}>
        <p className={classNames(typography.bodyM, styles.tableTitle)}>{tr.rich('text.holiday')}</p>
        <p className={classNames(typography.bodyM, styles.tableTitle)}>{tr.rich('text.date')}</p>
      </div>
      {holidays.map((holiday, key) => (
        <div className={styles.wrapperItem} key={key}>
          <p className={classNames(typography.bodyM, styles.tableItemName)}>{holiday.holidayName}</p>
          <div className={styles.tableItem}>
            {holiday.holidayDates.map((date, i) => (
              <p className={typography.bodyM} key={i}>
                {date}
              </p>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
